import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Person } from "../../models/person.model";

import { PersonService } from "../../services/person.service";

import { DialogPersonComponent } from "../dialog-person/dialog-person.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "ngx-view-persons",
  styleUrls: ["./view-persons.component.scss"],
  templateUrl: "./view-persons.component.html",
})
export class ViewPersonsComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //customer / supplier / employee /project
  @Input() shopId?: string = "";
  @Input() refId?: string = "";
  @Input() refName?: string = "";

  persons?: Person[] = [];
  person: Person = new Person();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  strSearch = "";
  uid = "anonymous";

  companyId = "anonymous";
  @ViewChild("title") title: ElementRef;
  @ViewChild("mobile") mobile: ElementRef;
  isMoreInfo = true;

  constructor(
    private userService: UserService,
    private personService: PersonService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.companyId = user.companyId;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
          this.companyId = "anonymous";
        }
        this.getPersons();
      });

    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [
      Validators.minLength(9),
      Validators.maxLength(11),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Quick create person
  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputMobile() {
    if (this.isMoreInfo) {
      this.mobile.nativeElement.focus();
    }
  }

  //load data
  getPersons() {
    this.loading = true;
    this.personService
      .getPersons(this.shopId, this.mode, this.refId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            dob: c.payload.doc.data().dob
              ? convertTimestamp(c.payload.doc.data().dob)
              : null,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          this.persons = data;

          console.log("getPersons:", this.persons);

          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
  }

  create() {
    this.person.shopId = this.shopId;
    this.person.fullName = this.person.fullName
      ? this.person.fullName.trim()
      : "";
    this.person.mobile = this.person.mobile ? this.person.mobile.trim() : "";

    switch (this.mode) {
      case "customer":
        this.person.customerId = this.refId;
        this.person.customerName = this.refName;
        break;
      case "supplier":
        this.person.supplierId = this.refId;
        this.person.supplierName = this.refName;
        break;
      case "employee":
        this.person.employeeId = this.refId;
        this.person.employeeName = this.refName;
        break;
      case "project":
        this.person.projectId = this.refId;
        this.person.projectName = this.refName;
        break;
      default:
        break;
    }

    if (this.person.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.personService
        .create(this.person)
        .then((data) => {
          this.person = new Person();
          this.title.nativeElement.focus();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onNew() {
    this.dialogService
      .open(DialogPersonComponent, {
        context: {
          header: "Tạo người liên hệ",
          mode: "new",
          person: this.person,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.person = new Person();
        }
      });
  }

  onEdit(item: Person) {
    if (item) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id == item.id) {
          this.persons[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    remove(this.persons, (e) => {
      return e.id == value;
    });
  }

  //Control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
